// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container{
    margin: 20px 10px;
}

.form-container input[type='text']{
    height: 25px;
    padding: 5px;
    outline: none;
    margin-left: 5px;
}

.deal-form{
    display: flex;
    border: 1px solid #343A40 ;
    border-radius: 5px;
    padding: 10px 10px;
    position: relative;
}

.deal-form .submit{
    position: absolute;
    bottom: 5px;
    right: -5px;
    /* justify-self: end; */
}

#deal-button{
    margin: 0px 10px;
    padding: 4px 8px;
}

#deal-button:hover{
    cursor: pointer;
}

.list-container{
    display: flex;
    flex-direction: column;
    
}

.list-container .single-list{
    margin: 10px 10px;
    display: flex;
    justify-content: space-between;
}
.list-container li{
    display: inline-block;
    width: 40%;
}

.list-container .cross-icon:hover{
    cursor: pointer;
}

.rendered-heading{
    margin: 5px 10px;
    font-size:medium;
    text-transform: uppercase;
}


.download-button:hover{
    cursor: pointer;
    background-color: #DEE2E6;
}

.heading-container span{
    color: red;
    margin-left: 5px;
    font-size: 15px;
    margin-bottom: 15px;
}

.buttons{
    margin-right: 10px;
    display: flex;
    width: 150px;
    justify-content: space-around;
}

.buttons button{
    padding: 2px 5px;
}

.agency{
    display: flex;
    flex-direction: column;
}

.agency span{
    color: red;
    font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/styles/deals.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;;AAE1B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;;AAGA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,eAAe;AACnB","sourcesContent":[".form-container{\n    margin: 20px 10px;\n}\n\n.form-container input[type='text']{\n    height: 25px;\n    padding: 5px;\n    outline: none;\n    margin-left: 5px;\n}\n\n.deal-form{\n    display: flex;\n    border: 1px solid #343A40 ;\n    border-radius: 5px;\n    padding: 10px 10px;\n    position: relative;\n}\n\n.deal-form .submit{\n    position: absolute;\n    bottom: 5px;\n    right: -5px;\n    /* justify-self: end; */\n}\n\n#deal-button{\n    margin: 0px 10px;\n    padding: 4px 8px;\n}\n\n#deal-button:hover{\n    cursor: pointer;\n}\n\n.list-container{\n    display: flex;\n    flex-direction: column;\n    \n}\n\n.list-container .single-list{\n    margin: 10px 10px;\n    display: flex;\n    justify-content: space-between;\n}\n.list-container li{\n    display: inline-block;\n    width: 40%;\n}\n\n.list-container .cross-icon:hover{\n    cursor: pointer;\n}\n\n.rendered-heading{\n    margin: 5px 10px;\n    font-size:medium;\n    text-transform: uppercase;\n}\n\n\n.download-button:hover{\n    cursor: pointer;\n    background-color: #DEE2E6;\n}\n\n.heading-container span{\n    color: red;\n    margin-left: 5px;\n    font-size: 15px;\n    margin-bottom: 15px;\n}\n\n.buttons{\n    margin-right: 10px;\n    display: flex;\n    width: 150px;\n    justify-content: space-around;\n}\n\n.buttons button{\n    padding: 2px 5px;\n}\n\n.agency{\n    display: flex;\n    flex-direction: column;\n}\n\n.agency span{\n    color: red;\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
